import {
    getContractInfo,
    getContractSignaturesInfo,
    getVolunteersContractInfo,
    getVolunteersContractSignaturesInfo,
} from '@/middlewares/services/contract.services'

/**
 * The two contracts of an event (one per audience, `contract.model isForVolunteers`), chosen by the
 * route (`contract` / `staff/contract`) instead of sniffing the pathname. Titles and the "who" column
 * are contractSignature.json keys.
 */
export const athletesContract = {
    key: 'athletes',
    isForVolunteers: false,
    title: 'Athlete contract',
    whoKey: 'Athlete / Team',
    requestAsk: 'Send an email to each athlete ?',
    requestMissingAsk: 'Are you sure you want to send a request by email to all athlete that did not sign ?',
    nobody: 'No athlete to sign yet',
    settingsPath: 'contract',
    reportsPath: 'contract-reports',
    fetchInfo: getContractInfo,
    fetchSignatures: getContractSignaturesInfo,
}

export const volunteersContract = {
    key: 'volunteers',
    isForVolunteers: true,
    title: 'Volunteer contract',
    whoKey: 'Volunteer',
    requestAsk: 'Send an email to each volunteer ?',
    requestMissingAsk: 'Are you sure you want to send a request by email to all volunteers that did not sign ?',
    nobody: 'No volunteer to sign yet',
    settingsPath: 'staff/contract',
    reportsPath: 'staff/contract-reports',
    fetchInfo: getVolunteersContractInfo,
    fetchSignatures: getVolunteersContractSignaturesInfo,
}
